import { createContext } from 'react';

export interface AuthContextType {
  isAuthModalOpen: boolean;
  authModalMode: 'sign-in' | 'sign-up';
  authRedirectUrl?: string;
  isUserProfileOpen: boolean;
  isPremium: boolean;
  isPremiumLoaded: boolean;
  openAuthModal: (mode: 'sign-in' | 'sign-up', redirectUrl?: string) => void;
  closeAuthModal: () => void;
  openUserProfile: () => void;
  closeUserProfile: () => void;
  requireAuth: (callback: () => void, redirectUrl?: string) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);